import React, { Component } from 'react';
import {
    StyledParentalControlLock,
    StyledParentalControlLockButton,
    StyledParentalControlLockCode,
    StyledParentalControlLockForgot,
    StyledParentalControlLockInvalid,
    StyledParentalControlLockLabel,
} from './ParentalControl.styles';
import ExternalLink from '../../../../Link/ExternalLink';

const ENTER_KEY = 13;
const CODE_LENGTH = 4;

export class ParentalControlLock extends Component {
    constructor(props) {
        super(props);

        this.state = { invalid: false, disabled: true };
    }

    _validate() {
        if (this.input.value === this.props.code) {
            this.props.onPlay();
        } else {
            this.setState({ invalid: true });
        }
    }

    _checkActive() {
        if (this.input.value.length === CODE_LENGTH) {
            this.setState({ disabled: false });
        } else {
            this.setState({ disabled: true });
        }
    }

    _onKeyUp(e) {
        if (e.keyCode === ENTER_KEY) {
            this._validate();
        } else {
            this._checkActive();
        }
    }

    render() {
        return (
            <>
                <StyledParentalControlLock>
                    <StyledParentalControlLockLabel htmlFor="parental-control-lock-code">
                        Skriv din kod
                    </StyledParentalControlLockLabel>
                    <StyledParentalControlLockCode
                        id="parental-control-lock-code"
                        type="password"
                        maxLength={CODE_LENGTH}
                        pattern="[0-9]*"
                        ref={(ref) => (this.input = ref)}
                        onKeyUp={(e) => this._onKeyUp(e)}
                        data-rt="parental-control-lock-code"
                    />

                    <StyledParentalControlLockButton
                        type="button"
                        disabled={this.state.disabled}
                        onClick={() => this._validate()}
                        isDisabled={this.state.disabled}
                        data-rt="parental-control-lock-code-enter"
                    >
                        Spela programmet
                    </StyledParentalControlLockButton>

                    {this.state.invalid && (
                        <StyledParentalControlLockInvalid>
                            Du har skrivit in fel kod - försök igen.
                        </StyledParentalControlLockInvalid>
                    )}
                </StyledParentalControlLock>
                <StyledParentalControlLockForgot>
                    <ExternalLink href="https://kontakt.svt.se/guide/nollstall-pin-kod">
                        Har du glömt din kod?
                    </ExternalLink>
                </StyledParentalControlLockForgot>
            </>
        );
    }
}

export default ParentalControlLock;
